import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { initGA } from "@/lib/gtag";

// Load the GA4 gtag.js tag on startup so it fires on every page. No-ops when
// REACT_APP_GA_MEASUREMENT_ID is unset (see src/lib/gtag.js).
initGA();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
